import { configureStore } from "@reduxjs/toolkit";
import { formIsOpen } from "./slices/createPostForm";


export const store = configureStore({
    reducer: {
        formIsOpen,
    },
})